import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import PageHero from "../components/PageHero";
import { NEWS } from "../mock/mock";
import { useToast } from "../hooks/use-toast";

const News = () => {
  const { toast } = useToast();
  const categories = ["Tous", ...Array.from(new Set(NEWS.map((n) => n.category)))];
  const [active, setActive] = useState("Tous");

  const filtered = active === "Tous" ? NEWS : NEWS.filter((n) => n.category === active);

  return (
    <div>
      <PageHero
        title="Nouvelles"
        subtitle="Tendances, analyses et conseils en gouvernance TI et agilité."
        image="https://images.unsplash.com/photo-1542626991-cbc4e32524cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          {/* Filters */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-14">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 text-[13px] font-semibold uppercase tracking-wide rounded-full transition-colors duration-200 ${
                  active === c ? "bg-[#15324f] text-white" : "bg-[#f4f6f9] text-[#15324f] hover:bg-[#e2e8f0]"
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((n) => (
              <article key={n.id} className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 border border-slate-100 flex flex-col">
                <div className="h-52 overflow-hidden relative">
                  <img src={n.image} alt={n.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  {n.comingSoon && (
                    <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-wide text-white bg-[#15324f]/90 px-2.5 py-1 rounded">
                      À venir
                    </span>
                  )}
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="text-[11px] font-bold uppercase tracking-wide text-[#2f80c4] bg-[#2f80c4]/10 px-2.5 py-1 rounded">{n.category}</span>
                    <span className="flex items-center gap-1 text-xs text-slate-400"><Calendar size={13} /> {n.date}</span>
                    {n.readTime && (
                      <span className="flex items-center gap-1 text-xs text-slate-400"><Clock size={13} /> {n.readTime}</span>
                    )}
                  </div>
                  <h3 className="text-lg font-bold text-[#15324f] leading-snug mb-3 group-hover:text-[#2f80c4] transition-colors" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {n.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-5 flex-1">{n.excerpt}</p>
                  {n.comingSoon ? (
                    <button
                      onClick={() => toast({ title: "Article à venir", description: "Cet article sera disponible à l'avenir. Revenez bientôt !" })}
                      className="inline-flex items-center gap-2 text-slate-400 text-[13px] font-semibold uppercase tracking-wide cursor-default"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      Article disponible à l'avenir
                    </button>
                  ) : (
                    <Link
                      to={`/nouvelles/${n.id}`}
                      className="inline-flex items-center gap-2 text-[#2f80c4] text-[13px] font-semibold uppercase tracking-wide hover:gap-3 transition-all"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      Lire l'article <ArrowRight size={15} />
                    </Link>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;
